<template>
    <div class="shipping-options">
        <div v-for="shipmentMethod in shipmentMethods" :key="shipmentMethod.id" class="shipment">
            <SfRadio
                    :disabled="selectedRelais && shipmentMethod.id!==selectedMethod"
                    :selected="selectedMethod"
                    :value="shipmentMethod.id"
                    class="shipping"
                    name="shippingOption"
                    @input="selectMethod(shipmentMethod)"
            >
                <template #label>
                    <div class="label">
                        <div class="carrier">
                            <SfImage v-if="shipmentMethod.carrierImg" :alt="shipmentMethod.carrier"
                                     :src="shipmentMethod.carrierImg" height="91"
                                     placeholder="/assets/images/magicPlaceholder.gif"
                                     width="257"></SfImage>
                            <span v-else>{{ shipmentMethod.carrier }} </span>
                        </div>
                        <div class="shipment-description">
                            <div class="shipment-description-title">{{ shipmentMethod.name }}</div>
                            <div class="shipment-description-delivery">

                <span v-if="shipmentMethod.deliveryTimeUnit === 'DAYS'">
                {{ $tc('deliveryTime.day', shipmentMethod.deliveryTime) }}
                </span>
                                <span v-else-if="shipmentMethod.deliveryTimeUnit === 'HOURS'">
                   {{ $tc('deliveryTime.hour', shipmentMethod.deliveryTime) }}
                </span>
                            </div>
                        </div>
                    </div>

                </template>
                <template #details>
                    <div v-if="shipmentMethod.carrier === 'A2P'">
                        <div v-if="selectedRelais" class="address">

                            <p>
                                <span class="name">{{ selectedRelais.company }}</span><br/>
                                <span class="street">{{ selectedRelais.street }}</span><br/>
                                <span class="postcode">{{ selectedRelais.postCode }}</span>&nbsp;&nbsp; <span
                                    class="city">{{
                                selectedRelais.city
                                }}</span><br/>

                            </p>
                            <div class="address-actions">
                                <SfButton v-if="selectedMethod===shipmentMethod.id"
                                          class="sf-button--text color-tertiary"
                                          @click="openRelais">
                                    <span class="label"> {{ $t('relais.change') }}</span>
                                </SfButton>
                                <SfButton v-if="selectedMethod===shipmentMethod.id"
                                          class="sf-button--text color-tertiary"
                                          @click="removeRelais">
                                    <span class="label"> {{ $t('relais.remove') }}</span>
                                </SfButton>
                            </div>
                        </div>
                        <SfButton v-if="!selectedRelais && selectedMethod===shipmentMethod.id" @click="openRelais">
                            <span class="label"> {{ $t('relais.select') }}</span>
                        </SfButton>
                    </div>

                </template>
                <template #description>
                    <div class="price">
                        {{
                        (shipmentMethod.price.taxIncluded > 0) ? $n(shipmentMethod.price.taxIncluded, 'currency') : $t('free')
                        }}
                    </div>
                </template>
            </SfRadio>
        </div>
    </div>
</template>

<script>
import {
    SfRadio,
    SfImage,
    SfButton,
} from '@storefront-ui/vue';


export default {
    name: 'UserShipmentOptions',

    components: {
        SfRadio,
        SfImage,
        SfButton,
    },

    props: {
        selectedMethods: {
            default: []
        },
        shipmentMethods: {
            type: Array,
            required: true
        },
        selectedRelais: {
            default: null
        }
    },
    data() {
        return {
            getMethod: null
        }
    },
    computed: {
        selectedMethod: {
            get() {

                return this.getMethod;

            },
            set(val) {

                this.getMethod = val;

            }
        }
    },
    mounted() {
        const findMethod = this.shipmentMethods.find(val => {
            if (this.selectedMethods.includes(val.id))
                return val.id
        });
        if (findMethod) this.getMethod = findMethod.id
        else this.getMethod = null
    },
    methods: {
        selectMethod(shipmentMethod) {
            this.selectedMethod = shipmentMethod.id;
            this.$emit('submitSelectedShipmentMethod', shipmentMethod.id);
        },
        openRelais() {
            this.$emit('openRelais');
        },
        removeRelais() {
            this.$emit('removeRelais');
        }
    }
};
</script>

<style lang="scss" scoped>
.title {
  margin: var(--spacer-xl) 0 var(--spacer-base) 0;
  --heading-title-font-weight: var(--font-weight--bold);
}

.address {
  margin: var(--spacer-sm) 0;
  border: 1px solid var(--c-light);
  padding: var(--spacer-xs);
  font-size: var(--font-size--sm);

  p {
    font-weight: normal;
    margin: 0
  }

  &-actions {
    margin-top: var(--spacer-sm);
    display: flex;
    justify-content: space-between;
  }

  .sfbutton, .sfLink {
    display: inline-block;
    color: var(--c-tertiary);
  }
}

.table {
  margin: 0 0 var(--spacer-base) 0;

  &__row {
    justify-content: space-between;
  }

  @include for-desktop {
    &__header {
      text-align: center;

      &:last-child {
        text-align: right;
      }
    }
    &__data {
      text-align: center;
    }
    &__description {
      text-align: left;
      flex: 0 0 12rem;
    }
    &__image {
      --image-width: 5.125rem;
      text-align: left;
      margin: 0 var(--spacer-xl) 0 0;
    }
  }
}

.shipment {

  &__items {
    grid-area: item;
    padding: 0 var(--spacer-base);
    margin-bottom: var(--spacer-base);
  }

  &__item {
    margin-bottom: var(--spacer-sm);
    border-bottom: 1px solid #c3c3c3;

    &:last-of-type {
      margin-bottom: 0;
      border-bottom: none;
    }
  }
}

.shipping-options {
  &__label {
    display: flex;
    justify-content: space-between;
  }

  &__description {
    --radio-description-margin: 0;
    --radio-description-font-size: var(--font-xs);
  }

  .form {
    &__action {
      @include for-desktop {
        flex: 0 0 100%;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .sf-radio.is-active {
    background-color: transparent;
  }

  .sf-radio.is-disabled {
    background-color: transparent;
  }

  .shipment {
    margin-bottom: var(--spacer-base);

    ::v-deep {
      .sf-radio.shipping {
        border: 1px solid var(--_c-primary-light);
        border-radius: 4px;
        padding: var(--spacer-sm);
        margin: var(--spacer-base) 0;
        box-shadow: 0 2px 6px -2px rgb(0 0 0 / 10%);
        transition: 0.2s ease all;

        &:hover, &.is-active {
          border: 1px solid var(--c-primary);
          box-shadow: 0 2px 6px -2px rgb(0 0 0 / 25%);
        }


        &.is-disabled {
          border: 1px solid var(--_c-primary-light);
          box-shadow: none;
          filter: grayscale(100%);
          opacity: 0.5;

          &:hover {
            border: 1px solid var(--_c-primary-light);
            box-shadow: none;
          }
        }
      }

      .sf-radio__content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        padding: 0;

        .label {
          font-size: var(--font-size--base);
          font-weight: var(--font-weight--bold);
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .sf-image {
            width: auto;
            height: auto;
          }

          .shipment-description {
            &-title {

            }

            &-delivery {
              font-weight: var(--font-weight--normal);
            }
          }
        }

        .price {
          font-size: var(--font-size--lg);
          font-weight: var(--font-weight--bold);
          @include for-mobile {
            width: 100%;
            text-align: right;
          }
        }
      }

      .sf-radio__content {
        margin-left: 0;
        @include for-mobile {
          align-items: top;
          margin-left: 10px;
        }
      }

      .sf-radio__container {
        padding: 0;
        display: flex;
        align-items: center;

      }


    }

  }
}
</style>
